import { getFormattedAddress } from "../../Lit/acc-mixins/src/modules/formatters/index.js";
import { useTranslation } from "react-i18next";
import defaultContent from "../../../content/profile";
import { useAppSelector, RootState } from "../../../store";
import { IconAddress } from "../../../common/icons/IconAddress/IconAddress";
import "./ABOAddress.scss";

type Props = {
  addresses: {
    addressLines: string[];
    municipality: string;
    region: string;
    postalCode: string;
    country: string;
    type: string;
  };
  privacyFlag: boolean;
  applicantTrackOnclick: (event: string) => void;
  hideLabel?: boolean;
  hideCopyIcon?: boolean;
};

const ABOAddress = (props: Props) => {
  const { t } = useTranslation(["profile"]);
  const { addresses, privacyFlag, applicantTrackOnclick, hideLabel = false, hideCopyIcon = false } = props;
  const defaultAddresses = {
    addressLines: [],
    municipality: "",
    region: "",
    postalCode: "",
    country: "",
    type: "",
  };

  const {
    addressLines: address_lines,
    municipality,
    region,
    postalCode: postal_code,
    country,
  } = addresses || defaultAddresses;

  const { address = "", addressLinesDivider } =
    useAppSelector((state: RootState) => state?.boot?.configuration?.profile?.format) ?? {};

  // object format expected by mixins
  const preFormattedAddress = {
    address_lines,
    municipality,
    region,
    postal_code,
    country,
  };

  // formatting expected by mixins
  const addressFormat = address
    .split(" ")
    .map((format: string) => format.replace(/[A-Z]/g, (address) => `_${address.toLocaleLowerCase()}`))
    .join(" ");

  const formattedAddress = getFormattedAddress(preFormattedAddress, {
    string: addressFormat,
    divider: addressLinesDivider,
  });

  const showValidAddress = formattedAddress && formattedAddress !== "--" && privacyFlag !== true;
  const displayAddress = showValidAddress ? formattedAddress : "";

  const PrimaryAddress = () => (
    <div className="leaf-abo-address__address">
      <div>{displayAddress}</div>
    </div>
  );

  const copyTextToClipboard = () => {
    navigator.clipboard.writeText(displayAddress);
    applicantTrackOnclick("address");
  };

  if (displayAddress === "") {
    return <></>;
  }

  return (
    <div className="leaf-abo-address">
      <div className="leaf-abo-address__content">
        {hideLabel === false && (
          <div className="leaf-abo-address__label">{`${t(
            "leaf.primaryAddress",
            defaultContent["leaf"]["primaryAddress"],
          )}`}</div>
        )}
        <PrimaryAddress />
      </div>
      {privacyFlag === false && showValidAddress && hideCopyIcon === false && (
        <button
          aria-label={`${t("leaf.copyAddress", defaultContent["leaf"]["copyAddress"])}`}
          className="leaf-abo-address__icon--copy"
          onClick={copyTextToClipboard}
        >
          <span aria-hidden="true">
            <IconAddress />
          </span>
        </button>
      )}
    </div>
  );
};

export default ABOAddress;
